import { Link, useLocation, useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Helmet } from 'react-helmet-async';

const VolunteerScreen = () => {
  return (
    <Container>
      <Helmet>
        <title>Volunteer</title>
      </Helmet>
      <img className="img-fluid" src="images/eating.jpg" />
      <h1 className="my-3">Volunteer</h1>
      <p>
        Charities will always need help. It doesn’t stop! Good thing the giving doesn’t stop either. Other ways you can help are:
      </p>
      <p>
      <h3>Volunteer For Charity</h3>Do you want to get involved? You can volunteer your time, effort, or expertise in some of our programs and projects. Just let us know how you want to be involved through our Contact Us page. If something comes up that suits you, we’ll let you know.
      </p>
      <p>
      <h3>Share our Site</h3>
      Show people that you support <a href="https://projectdream.code200.dev">https://projectdream.code200.dev</a> and help spread the word about the work we do. It’s free!
      </p>
      Feel free to contact us:
      <p><i className="fa fa-envelope" />&nbsp;projectdream@code200.dev</p>

    </Container>
  );
}

export default VolunteerScreen;
